<template>
    <div>
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="isActive" 
            @close="closePopUp"
            style="border-radius: 10px !important;"
            id="popUpQuantityChat"
        >
        
            <div>
                
                <span id="display-span-orders">
                    <vs-icon @click="closePopUp" class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>
                    <p class="ml-2" style="font-size: 16px; width: 400px;">Selecione o Desconto Unitário</p>
                </span>
            </div>

            <div class="flex">
                <div  class="w-2/5 mr-6 ml-6">
                    <div class="mt-4 ml-1" style="margin-bottom:2.7rem;">
                        <ul>
                            <li>
                                <vs-radio v-model="discountType" vs-value="value">
                                    Valor
                                </vs-radio>
                            </li>

                            <li>
                                <vs-radio v-model="discountType" vs-value="percentage">
                                    Porcentagem
                                </vs-radio>
                            </li>
                        </ul>
                    </div>

                </div>

                <div class="w-3/5">
                    <p class="mb-1"><span style="font-weight:600;"><span v-if="dataToSetDiscount.isService">Serviço: </span><span v-else>Produto: </span></span>{{ dataToSetDiscount.product.name }}</p>
                    <p class="mb-1"><span style="font-weight:600;">Valor Unitário:</span> R$ {{ dataToSetDiscount.product.price }}</p>
                    <p class="mb-1"><span style="font-weight:600;">Máximo Percentual Desconto:</span> {{ dataToSetDiscount.product.discount_percentage }} %</p>
                </div>

            </div>

            <div class="flex mb-1 mt-1">
                <div class="w-2/5 mr-6 ml-6">
                    <div v-if="discountType === 'value'">
                        <p>Digite o Preço com desconto unitário</p>
                        <div :class="{ 'percentHighlightFocus': isInputFocused, 'percentHighlight': !isInputFocused }" style="width:140px;">
                            <span class="p-2 pr-0" style="font-size: 13.8px;">R$</span>
                            <vs-input 
                            id="discount-price-input"
                            v-model="discountValue"
                            @focus="highlightInput" 
                            @blur="highlightInput" 
                            v-mask=" ['#.##','##.##','###.##','####.##','#####.##','######.##',]" 
                            />          
                        </div> 
                    </div>
        
                    <div v-else-if="discountType === 'percentage'">
                        <p>Digite a Porcentagem do desconto</p>
                        <span id="percent-input-span" :class="{ 'percentHighlightFocus': isInputFocused, 'percentHighlight': !isInputFocused }">
                        
                            <vs-input id="percent-input" 
                            class="percentHighloght"
                            @focus="highlightInput" 
                            @blur="highlightInput" 
                            v-mask="['#.##', '##.##', '###.##']" 
                            v-model="discountPercentage"
                            />
                            
                            <feather-icon
                            icon="PercentIcon"
                            svgClasses="h-5 w-5"
                            class="mr-3"
                            />
                        </span>
                        
                    </div>
                </div>

                <div class="w-3/5">
                    <p style="font-weight:500; font-size:20px;">Valor unitário com desconto</p>
                    <p style="font-weight:600; font-size:20px;">R$ {{ discountValue }}</p>
                </div>
                
            </div>

            <p v-if="!canSetDiscount" class="ml-6" style="margin-top:3rem; margin-bottom:0; !important">

                <span v-if="discountType === 'value'" class="p-3 no-discount-warning">

                    <span v-if="discountValue > dataToSetDiscount.product.price">
                        O valor do {{ dataToSetDiscount.isService ? 'serviço' : 'produto' }} não deve ser maior que <strong>R$ {{ (dataToSetDiscount.product.price).toFixed(2) }}</strong>
                    </span>
                    
                    <span v-else>
                        O valor maxímo para o desconto do {{ dataToSetDiscount.isService ? 'serviço' : 'produto' }} é <strong>R$ {{ (dataToSetDiscount.product.discount_price).toFixed(2) }}</strong>
                    </span>

                </span>

                <span v-if="discountType === 'percentage'" class="p-3 no-discount-warning">
                    A porcentagem máxima de desconto disponível é para o {{ dataToSetDiscount.isService ? 'serviço' : 'produto' }} é <strong>{{ dataToSetDiscount.product.discount_percentage }}%</strong>
                </span>
            </p>

            <vs-button 
             @click="setDiscount()" 
             :disabled="!canSetDiscount"
             class="btn-drop px-3 mr-5 mt-3 mb-2" 
             type="filled" 
             icon="keyboard_arrow_right" 
             icon-after style="float: right !important; border-radius: 12px;"
            >
                Continuar
            </vs-button>
        </vs-popup>
    </div>
</template>

<script>

    export default {
        name: 'DiscountPopUp',
        data() {
            return {
                discountType: 'value',
                discountPercentage: 0.0,
                discountValue: null,
                isInputFocused: false,
                canSetDiscount: true,
            }
        },
        methods: {
            closePopUp() {
                if(this.dataToSetDiscount.isService){
                    this.$emit('backToDiscountModalService')
                }else{
                    this.$emit('backToQuantity');
                }
            },
            highlightInput() {
                this.isInputFocused = !this.isInputFocused;
            },
            setDiscount() {
                if (this.dataToSetDiscount.isService) {
                    this.$emit('setNewDiscountService', this.discountValue, this.dataToSetDiscount.index)
                }
                else {
                    this.$emit('setNewDiscountPrice', this.discountValue, this.dataToSetDiscount.index)
                }
            },
            incorrectDiscountNotify() {
                this.$vs.notify({
                    color: 'warning',
                    title: 'Aviso:',
                    text: 'Desconto não permitido!'
                });
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            dataToSetDiscount: {
                type: Object,
                required: true
            }
        },
        watch: {
            isActive() {
                if (this.isActive) {
                    if (this.dataToSetDiscount.product.discount_price === undefined) {
                      this.dataToSetDiscount.product.discount_price = this.dataToSetDiscount.product.price
                    } 
                    this.discountValue = (this.dataToSetDiscount.product.discount_price).toFixed(2)
                    if (this.dataToSetDiscount.product.discount_price === this.dataToSetDiscount.product.price) {
                        this.discountPercentage = 0.00
                    } 
                    else {
                        this.discountPercentage = (this.dataToSetDiscount.product.discount_percentage).toFixed(2)
                    }

                    if (this.dataToSetDiscount.product.discount_percentage === 0.00) {
                        this.canSetDiscount = false
                    }
                    
                }
            },
            'discountValue': {
                handler() {
                    if (this.discountType === 'value') {
                        let discount = this.discountValue / this.dataToSetDiscount.product.price;
                        let sum = discount * 100
                        this.discountPercentage = (100 - sum).toFixed(2);

                        if (this.dataToSetDiscount.product.discount_percentage === 100) {
                            this.canSetDiscount = this.discountValue <= this.dataToSetDiscount.product.price ? true : false;
                        }
                        else {
                            if (
                                this.discountValue >= this.dataToSetDiscount.product.discount_price &&
                                this.discountValue <= this.dataToSetDiscount.product.price
                            ) {
                                this.canSetDiscount = true
                            } else {
                                this.canSetDiscount = false
                            }
                        }
                    }
                }
            },
            'discountPercentage': {
                handler() {
                    if (this.discountType === 'percentage') {
                        let percentage = (100 - this.discountPercentage) / 100
                        this.discountValue = (percentage * this.dataToSetDiscount.product.price).toFixed(2);

                        this.canSetDiscount = this.discountPercentage <= this.dataToSetDiscount.product.discount_percentage ? true : false;
                    }
                }
            },
        },
    }
</script>

<style lang="scss">
    #popUpQuantityChat div.vs-popup {
        .vs-popup--content {
            padding: 15px;
            margin: 0;
        }
        margin: 0;
        border-radius: 18px !important;
        border: solid 1.2px;
        border-color: rgba(18, 17, 17, 0.769);
        width: 750px !important;
        .vs-popup--header {
            background-color: transparent !important;
            .vs-popup--title {
                background-color: transparent !important;
                h3 {
                    background-color: transparent !important;
                }
            }
        }
        header {
            background-color: transparent !important;

        }
        .d-flex.flex-row.items-center {
            display: flex;
            justify-content: space-evenly;
        }
        .vs-input-number.vs-input-number-size-null.vs-input-number-primary {
            background-color: #e3e2e236 !important;
            width: 110px;
        }
        td.td.vs-table--td:last-of-type {
            width: 150px;
        }
    }
    #warn {
        transform: translateX(4.8em);
        border-radius: 50%;
        width: 2em;
    }

    .percentage-symbol {
        font-size: 20px;
    }
    #percent-input {
        width: 110px;
        box-shadow: none !important;
        border:none !important;
        background-color: transparent;        
        font-size: 15px;
        background-color: transparent; 
    }
    #percent-input-span {
        display: inline-flex; 
        align-items: center;
        .vs-con-input-label {
            width:110px;
            border-radius:13px;
        }

        border: 1px solid #c0c4cc;
        border-radius: 14px;
        

        .vs-con-input-label .vs-con-input .vs-input--input{
            border:none !important;
           
            
        }
        .vs-con-input-label .vs-con-input .vs-input--input:focus{
            border: none !important;
            box-shadow: none !important;
        }
    }
    .percentHighlightFocus{
        display: inline-flex; 
        align-items: center; 
        border: 1px solid #409eff !important; 
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        border-radius: 14px; 
        transition:.3s;
    }
    .percentHighlight{
        border: 1px solid #c0c4cc;
        display: inline-flex; 
        align-items: center; 
        border-radius: 14px; 
        transition:.3s;
    }
    #discount-price-input {
        width: 115px;
        box-shadow: none !important;
        border:none !important;
        background-color: transparent;        
        font-size: 15px;
        background-color: transparent; 
    }
    .no-discount-warning {
        border-radius:14px; 
        background-color:#ffa60045;
        font-size: 15px;
        font-weight: 400;
        color:black;
        display: block !important;
        margin-top: .7em;
        width: fit-content;
    }

</style>
